"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _DirectLink = _interopRequireDefault(require("./DirectLink"));

var _UserSelection = _interopRequireDefault(require("./UserSelection"));

var _MNet = _interopRequireDefault(require("./MNet"));

var _FourButton = _interopRequireDefault(require("./FourButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OfferPage = function OfferPage(_ref) {
  var offer = _ref.offer,
      tracking = _ref.tracking,
      email = _ref.email,
      isRedirect = _ref.isRedirect,
      isSubmission = _ref.isSubmission,
      theme = _ref.theme;
  var history = (0, _reactRouterDom.useHistory)();
  (0, _react.useEffect)(function () {
    if (!offer) {
      history.push('/');
      return;
    }

    ;
  }, [offer, history]);

  var routedOfferPage = function routedOfferPage() {
    switch (offer.offer_page) {
      case 'direct_link':
        return /*#__PURE__*/_react.default.createElement(_DirectLink.default, {
          isRedirection: isRedirect,
          isSubmission: isSubmission,
          url: offer['url'],
          jump: offer['jump'],
          tracking: tracking,
          email: email
        });

      case 'selection':
        return /*#__PURE__*/_react.default.createElement(_UserSelection.default, {
          theme: theme,
          offer: offer,
          tracking: tracking,
          email: email
        });

      case 'four_button':
        return /*#__PURE__*/_react.default.createElement(_FourButton.default, {
          offer: offer,
          tracking: tracking,
          email: email
        });

      case 'mNet':
        return /*#__PURE__*/_react.default.createElement(_MNet.default, {
          user: {
            sid: tracking['sid'],
            eid: tracking['eid'],
            hsid: tracking['hsid'],
            page: offer['url']
          },
          tracking: tracking,
          email: email
        });

      default:
        console.log('offer_page not recognized!!!!', offer);
        return /*#__PURE__*/_react.default.createElement("h1", null, "Oh no! an error! Please refresh the page...");
    }

    ;
  };

  return offer ? routedOfferPage() : null;
};

var _default = OfferPage;
exports.default = _default;

//# sourceMappingURL=OfferPage.jsx.map